module.exports = __webpack_public_path__ + "static/media/shop_beach_3.8ee0975c.svg";